import { render, staticRenderFns } from "./GeneralIngoingInvoiceDetails.vue?vue&type=template&id=00395b15&"
import script from "./GeneralIngoingInvoiceDetails.vue?vue&type=script&lang=ts&"
export * from "./GeneralIngoingInvoiceDetails.vue?vue&type=script&lang=ts&"
import style0 from "./GeneralIngoingInvoiceDetails.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VChip,VCol,VRow})
